import {
  IsIn,
  IsString,
  IsOptional,
  IsNotEmpty,
  IsDateString,
} from 'class-validator';

export class FormSettingsSectionDto {
  @IsIn(['0', '1'])
  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  anonymous: '0' | '1';

  @IsIn(['0', '1'])
  @IsString({ message: 'Обязательное поле' })
  @IsNotEmpty({ message: 'Обязательное поле' })
  showAnswers: '0' | '1';

  @IsDateString()
  @IsString()
  @IsOptional()
  completionDate?: string;

  @IsString()
  @IsOptional()
  completionTime?: string;
}
